export const FIELD_OPTIONS = {
  route: [
    { value: "any", label: "Все поля" },
    { value: "id", label: "ID маршрута" },
    { value: "route_number", label: "Номер маршрута" },
    { value: "route_date", label: "Дата маршрута" },
    { value: "time_from", label: "Время (от)" },
    { value: "time_to", label: "Время (до)" },
    { value: "driver", label: "Водитель" },
    { value: "operator", label: "Оператор" },
    { value: "car", label: "Автомобиль" },
    { value: "route_districts", label: "Районы" },
    { value: "route_status", label: "Статус маршрута" },
    { value: "is_ready_for_upload", label: "Готов к выгрузке" },
    { value: "is_uploaded", label: "Выгружен" },
  ],
  receipt: [
    { value: "any", label: "Все поля" },
    { value: "id", label: "ID квитанции" },
    { value: "receipt_number", label: "Номер квитанции" },
    { value: "contract_number", label: "Номер договора" },
    { value: "client_name", label: "Имя клиента" },
    { value: "time", label: "Время" },
    { value: "status", label: "Статус квитанции" },
    { value: "route_id", label: "ID маршрута" },
  ],
  product: [
    { value: "any", label: "Все поля" },
    { value: "id", label: "ID товара" },
    { value: "product_number", label: "Номер товара" },
    { value: "product_name", label: "Название товара" },
    { value: "actual_quantity", label: "Количество" },
    { value: "marks", label: "Маркировки" },
    { value: "receipt_number", label: "Номер квитанции" },
  ],
};
